import { css } from "emotion";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType
} from "office-ui-fabric-react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { dialogPropsSelector, uiActions } from "../../../store/ui.store";

/**
 * 変更履歴ダイアログ
 */
export const ChangeHistoryDialog = () => {
  const { isOpen, title, isModal } = useSelector(dialogPropsSelector);
  const dispatch = useDispatch();
  const closeDialog = () =>
    dispatch(uiActions.USER_CLICKED_CLOSE_DIALOG_BUTTON());

  return (
    <Dialog
      hidden={!isOpen}
      onDismiss={closeDialog}
      dialogContentProps={{
        type: DialogType.largeHeader,
        title,
        styles: { header: { textAlign: "center" } }
      }}
      modalProps={{
        isBlocking: isModal,
        containerClassName: css`
          height: 90vh;
          max-height: 90vh;
          width: 90vw;
          max-width: 90vw;
        `
      }}
    >
      <h1 style={{ textAlign: "center", fontSize: "160px", color: "red" }}>
        未実装
      </h1>
      <DialogFooter>
        <DefaultButton onClick={closeDialog} text="閉じる" />
      </DialogFooter>
    </Dialog>
  );
};
